export enum Routes {
  SalesRouter = '/sales/*',
  PricingRulesPage = 'pricing-rules',
  CustomersPage = 'customers',
  SalesOrderPage = 'sales-order',
  PickingPage = 'picking',
  ShippingPage = 'shipping',
}
